import { createSelector, createSlice } from '@reduxjs/toolkit';
import 'react';
import 'react-redux';

const selectScores = (state) => state.scores.values;
const selectScoredDataset = (state) => { var _a; return (_a = state.scores.scoredDataset) !== null && _a !== void 0 ? _a : {}; };
const selectComparisonScores = (state) => state.scores.comparisonValues;

const selectTableInfo = (state) => state.tableInfo;
createSelector(selectTableInfo, (tableInfo) => tableInfo.siderWidth);

function toColumnMetaInfo(fields) {
    return fields.map((field) => {
        var _a, _b;
        const histogramMax = Math.max(...(((_a = field.statistics) === null || _a === void 0 ? void 0 : _a.histogram) || [])) || 1; // todo temporary fix, wait for BE
        let histogramBars = [];
        let dataWidth = 0;
        const isDiscreteColumn = ((_b = field.statistics) === null || _b === void 0 ? void 0 : _b.textCategories) !== null;
        if (field.statistics && field.statistics.histogram) {
            const min = field.statistics.min;
            const max = field.statistics.max;
            const step = field.statistics.histogramStep || 1; // todo temporary fix, wait for BE
            dataWidth = max - min;
            histogramBars = field.statistics.histogram.map((yVal, index, arr) => {
                const bar = {
                    x0: min + step * index,
                    x: index === arr.length - 1 ? max : min + step * (index + 1),
                    y0: 0,
                    y: arr.length !== 0 ? yVal : yVal || 1, // todo temporary fix, wait for BE
                };
                return bar;
            });
        }
        const meta = Object.assign(Object.assign({}, field), { histogramMax,
            histogramBars,
            dataWidth,
            isDiscreteColumn });
        return meta;
    });
}

const DEFAULT_SIDER_WIDTH = 355;
const MAX_SIDER_WIDTH = DEFAULT_SIDER_WIDTH * 2;
const initialState$1 = {
    id: '',
    name: '',
    isLoading: false,
    tableDataSize: 0,
    numRows: 0,
    numColumns: 0,
    columns: [],
    columnsMap: {},
    columnIds: [],
    columnIndexes: {},
    scoringTemplateId: null,
    comparisonScoringTemplateId: null,
    isTemplatesComparisonMode: false,
    missingValues: 0,
    siderWidth: DEFAULT_SIDER_WIDTH,
};
const tableInfoSlice = createSlice({
    name: 'tableInfo',
    initialState: initialState$1,
    reducers: {
        initTableInfo(state, action) {
            const { data } = action.payload;
            state.id = data._id;
            state.name = data.fileName;
            state.tableDataSize = data.fileSize;
            state.numRows = data.rowCount;
            state.numColumns = data.fields.length;
            state.columns = toColumnMetaInfo(data.fields);
            state.columnIds = data.fields.map((field) => field.name);
            state.comparisonScoringTemplateId = null;
            state.isTemplatesComparisonMode = false;
            state.columnsMap = state.columns.reduce((acc, col) => {
                acc[col.name] = col;
                return acc;
            }, {});
            state.columnIndexes = state.columns.reduce((acc, col, index) => {
                acc[col.name] = index;
                return acc;
            }, {});
            // TODO need to discuss
            state.scoringTemplateId = {
                parentId: data.scoringTemplateId,
                id: data.scoringTemplateId,
            };
            state.missingValues = data.missingValues;
        },
        toggleTableInfoLoading(state, action) {
            state.isLoading = action.payload;
        },
        setIsTemplatesComparisonMode(state, action) {
            state.isTemplatesComparisonMode = action.payload;
        },
        setTableScoringTemplateId(state, action) {
            state.scoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setTableComparisonScoringTemplateId(state, action) {
            state.comparisonScoringTemplateId = action.payload
                ? { parentId: action.payload.parentId, id: action.payload.id }
                : null;
        },
        setSiderWidth(state, action) {
            let width = action.payload;
            if (width > MAX_SIDER_WIDTH) {
                width = MAX_SIDER_WIDTH;
            }
            else if (width < DEFAULT_SIDER_WIDTH) {
                width = DEFAULT_SIDER_WIDTH;
            }
            state.siderWidth = width;
        },
    },
});
tableInfoSlice.actions;

const initialState = {
    scoredDataset: {},
    values: {},
    comparisonValues: {},
};
const scoresSlice = createSlice({
    name: 'scores',
    initialState,
    reducers: {
        setScoredDataset(state, action) {
            state.scoredDataset = action.payload;
        },
        setScores(state, action) {
            state.values = action.payload;
        },
        appendScores(state, action) {
            state.values = Object.assign(Object.assign({}, state.values), action.payload);
        },
        appendScoresAt(state, action) {
            const { scores, comparisonScores } = action.payload;
            state.values = Object.assign(Object.assign({}, state.values), scores);
            state.comparisonValues = Object.assign(Object.assign({}, state.comparisonValues), comparisonScores);
        },
        overwriteScores(state, action) {
            state.values = action.payload;
        },
    },
    extraReducers: {
        [tableInfoSlice.actions.initTableInfo.type]: (state) => {
            state.values = {};
            state.comparisonValues = {};
        },
    },
});
const { setScoredDataset, setScores, appendScores, appendScoresAt, overwriteScores, } = scoresSlice.actions;

export { appendScores, appendScoresAt, overwriteScores, scoresSlice, selectComparisonScores, selectScoredDataset, selectScores, setScoredDataset, setScores };
//# sourceMappingURL=index.js.map
